import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4d408d46"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "max-w-5xl mx-auto" };
const _hoisted_2 = { class: "button-row" };
const _hoisted_3 = { class: "panel" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "panel-title" }, "ポイント詳細", -1));
const _hoisted_5 = { class: "pointinfo-wrapper" };
const _hoisted_6 = { class: "panel" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "panel-title" }, "付与対象者一覧", -1));
const _hoisted_8 = { class: "table-wrapper" };
const _hoisted_9 = { class: "result-table" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { class: "crm_customer_id" }, "顧客ID"),
        /*#__PURE__*/ _createElementVNode("th", { class: "user_name" }, "氏名"),
        /*#__PURE__*/ _createElementVNode("th", { class: "mobile_phone_number" }, "電話番号"),
        /*#__PURE__*/ _createElementVNode("th", { class: "grant_type_detail" }, "付与種別"),
        /*#__PURE__*/ _createElementVNode("th", { class: "history_date" }, "付与日時")
    ])
], -1));
const _hoisted_11 = { class: "crm_customer_id" };
const _hoisted_12 = { class: "user_name" };
const _hoisted_13 = { class: "mobile_phone_number" };
const _hoisted_14 = { class: "grant_type_detail" };
const _hoisted_15 = { class: "history_date" };
const _hoisted_16 = { class: "table-footer" };
const _hoisted_17 = ["disabled"];
const _hoisted_18 = { class: "page-indicator" };
const _hoisted_19 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Title = _resolveComponent("Title");
    const _component_ModalQrCode = _resolveComponent("ModalQrCode");
    const _component_PointInfo = _resolveComponent("PointInfo");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Title, {
            msg: "ポイント付与結果",
            submsg: "Point Grant Result"
        }),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
                class: "btn-primary",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => ($options.exportCsv && $options.exportCsv(...args)))
            }, "CSV出力"),
            _createElementVNode("button", {
                class: "btn-primary",
                onClick: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => ($options.openModal && $options.openModal(...args)))
            }, "ポイントQR表示"),
            _createVNode(_component_ModalQrCode, {
                type: $data.type,
                id: $data.pointBulkGrantHistoryId,
                name: $data.name,
                value: $data.value,
                visible: $data.show,
                onClose: $options.closeModal
            }, null, 8, ["type", "id", "name", "value", "visible", "onClose"])
        ]),
        _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_PointInfo, { point_bulk_grant_history_id: $data.pointBulkGrantHistoryId }, null, 8, ["point_bulk_grant_history_id"])
            ])
        ]),
        _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
                _createElementVNode("table", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.pagedInfo, (r, i) => {
                            return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                _createElementVNode("td", _hoisted_11, _toDisplayString(r.crm_customer_id), 1),
                                _createElementVNode("td", _hoisted_12, _toDisplayString(r.user_name), 1),
                                _createElementVNode("td", _hoisted_13, _toDisplayString(r.mobile_phone_number), 1),
                                _createElementVNode("td", _hoisted_14, _toDisplayString(r.grant_type_detail), 1),
                                _createElementVNode("td", _hoisted_15, _toDisplayString(r.history_date), 1)
                            ]));
                        }), 128))
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                    class: "pg-btn",
                    disabled: $data.infoPage <= 1,
                    onClick: _cache[2] || (_cache[2] = ($event) => ($options.setInfoPage($data.infoPage - 1)))
                }, " ‹ ", 8, _hoisted_17),
                _createElementVNode("div", _hoisted_18, _toDisplayString($data.infoPage) + " / " + _toDisplayString($options.infoTotalPages), 1),
                _createElementVNode("button", {
                    class: "pg-btn",
                    disabled: $data.infoPage >= $options.infoTotalPages,
                    onClick: _cache[3] || (_cache[3] = ($event) => ($options.setInfoPage($data.infoPage + 1)))
                }, " › ", 8, _hoisted_19)
            ])
        ])
    ]));
}
